import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Table } from "react-bootstrap";
import { useNavigate } from "react-router";
import {
  backblack,
  dataLoading,
  NoDataScreen,
} from "../../../../assets/assets";
import httpApiCall from "../../../../service/api.service";
import { getStorageValue } from "../../../../service/shared.service";
import toastr from "../../../elements/toast";
import "./training-list.scss";

const TrainingList = (props: any = []) => {
  const navigate = useNavigate();
  const [trainings_list, set_training_list] = useState([]);
  const [training_data, set_training_data] = useState({
    training_event_time_slot_id: "",
    doctor_id: "",
  });
  const [loader, set_loader] = useState(false);
  const [totalRecords, set_totalRecords] = useState(0);
  const [showModal, set_showModal] = useState(false);
  let [selected_training_type, set_selected_training_type] =
    useState("upcoming");
  const [training_status, set_training_status] = useState("");
  const [page_index, set_page_index] = useState(0);
  const profile = getStorageValue("partnerProfile");
  const [selectedChoice, setSelectedChoice] = useState({
    value: "upcoming",
    label: "Scheduled",
  });
  const choices = [
    {
      value: "upcoming",
      label: "Scheduled",
    },
    {
      value: "old",
      label: "Past",
    },
  ];
  const toastrService = new toastr(true);

  useEffect(() => {
    getTrainingsList();
  }, []);
  const getTrainingsList = async () => {
    const data = {
      access_token: getStorageValue("partnerToken"),
      limit: 10,
      page: page_index,
      hideLoader: true,
      time_type: selected_training_type,
      remove_limit: 0,
      status: training_status,
      partner_id: profile[0].partner_id,
    };
    set_loader(true);
    await httpApiCall({
      body: data,
      api: "get_partner_training_schdules",
      type: "post",
    }).then((response: any) => {
      set_loader(false);
      if (response.is_error) {
      } else {
        set_totalRecords(response.count);
        set_training_list(response.data);
      }
    });
  };

  const handleChoiceSelection = (item: any) => {
    selected_training_type = item.value;
    setSelectedChoice(item);
    getTrainingsList();
  };

  const ReScheduleTraining = (training_data: any) => {
    navigate(
      `/app/schedule-training/${training_data.training_event_time_slot_id}`
    );
  };

  const routeMe = (path: any) => {
    navigate(path);
  };

  const cancelTraining = (ele: any) => {
    set_training_data(ele);
    set_showModal(true);
  };

  const conFirmcancelTrainigs = () => {
    let data = {
      access_token: getStorageValue("partnerToken"),
      doctor_id: training_data["doctor_id"],
      event_id: training_data["training_event_time_slot_id"],
    };
    httpApiCall({ body: data, api: "/cancel_training", type: "post" }).then(
      (data: any) => {
        if (data && data.is_error == 0) {
          toastrService.showSuccess("Training cancelled successfully");
          getTrainingsList();
          set_showModal(false);
        } else {
          toastrService.showError(data.override_text || data.err);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  };

  const hideShowModal = (value: boolean) => {
    set_showModal(value);
  };
  const goBack = () => {
    navigate("/app/support");
  };

  return (
    <>
      <div className="back training">
        <button className="mb-0 border-0 bg-transparent" onClick={goBack}>
          {" "}
          <img src={backblack} alt="" />
          Back
        </button>
      </div>
      <div
        className={`training-list ${
          trainings_list && trainings_list.length
            ? "common_layout__right--inner-wrap"
            : ""
        }`}
      >
        <div className="row">
          <div className="col-12">
            <div className="payout-report--header">
              <div className="left-side header-cols">
                <Dropdown>
                  <Dropdown.Toggle variant="Secondary" id="dropdown-basic">
                    {selectedChoice.label}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {choices.map((item, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleChoiceSelection(item)}
                      >
                        {item.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="right-side header-cols">
                <button
                  className="button"
                  onClick={() => routeMe("/app/schedule-training")}
                >
                  + Schedule New Training
                </button>
              </div>
            </div>
            <div className="p-0 row mt-2 flex-nowrap justify-content-between">
              <>
                {!loader && trainings_list && trainings_list.length > 0 && (
                  <div className="payout-report--body grid-table--wrap">
                    <Table style={{ border: "solid 1px #ccc" }} hover size="sm">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Trianing Type</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trainings_list.map((element: any, i) => (
                          <tr key={i}>
                            <td> {i + 1} </td>
                            <td>
                              {element["doctor_partner_training_type"] == 8
                                ? "Partner Training"
                                : "Credee Training"}
                            </td>
                            <td>{element["start_show_date"]}</td>
                            <td>
                              {element.start_show_time},
                              {element.training_timezone_short_name}
                            </td>
                            <td>
                              {element.training_status !== 6
                                ? element.training_status_name
                                : "Missed"}
                            </td>
                            <td>
                              <>
                                {element.doctor_partner_training_type != 6 &&
                                  (selectedChoice.value === "old" ||
                                    element.training_status == 7) && (
                                    <span
                                      className="button  button-font"
                                      onClick={() =>
                                        ReScheduleTraining(element)
                                      }
                                      style={{
                                        minWidth: "53px",
                                        display: "inline-block",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Reschedule
                                    </span>
                                  )}
                                {element.doctor_partner_training_type != 6 &&
                                  selectedChoice.value === "upcoming" &&
                                  (element.training_status == 2 ||
                                    element.training_status == 3 ||
                                    element.training_status == 4) && (
                                    <span
                                      className="button cancel  button-font"
                                      onClick={() => cancelTraining(element)}
                                      style={{
                                        minWidth: "53px",
                                        display: "inline-block",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Cancel
                                    </span>
                                  )}
                                {element.doctor_partner_training_type == 6 ||
                                  (selectedChoice.value !== "old" &&
                                    element.training_status !== 7 &&
                                    !(
                                      element.training_status == 2 ||
                                      element.training_status == 3 ||
                                      element.training_status == 4
                                    ) && (
                                      <span
                                        style={{
                                          minWidth: "53px",
                                          display: "inline-block",
                                          cursor: "pointer",
                                        }}
                                      >
                                        -
                                      </span>
                                    ))}
                              </>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
                {/* {!loader && (!trainings_list || !trainings_list.length) &&
                                    <>
                                        <img src={NoDataScreen} alt="nodata" />
                                        <h4 className="fs-20-midheading mt-3">No Data Found!</h4>
                                    </>
                                } */}
              </>
            </div>
          </div>
        </div>
      </div>
      {loader && (
        <div className="no_data_v2 text-center ">
          <img src={dataLoading} alt="" />
        </div>
      )}
      {trainings_list && trainings_list.length == 0 && !loader && (
        <div className="no_data text-center no-data__right--screen">
          <img src={NoDataScreen} alt="nodata" />
          <h4 className="fs-20-midheading mt-3">No Data Found!</h4>
        </div>
      )}
      {showModal && (
        <div>
          <Modal
            show={showModal}
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="pt-0">
              <Modal.Title>
                <div className="left -ps-4 pt-3">
                  <span className="remove--dot">Cancel Training</span>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <h4 className="ps-1" style={{'fontSize': '19px','color': '#4b4b4b'}}>
                  Are you sure you want to cancel this training?
                </h4>
              </div>
            </Modal.Body>
            <Modal.Footer className="pb-3">
              <button
                className="button-font btn-white cancel--btn"
                onClick={() => conFirmcancelTrainigs()}
              >
                Confirm
              </button>
              <button
                className="button-font btn-white cancel--btn"
                onClick={() => hideShowModal(false)}
              >
                Cancel
              </button>
              {/* close modal */}
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};

export default TrainingList;

//    [ngStyle]="showMore ? {height: '47px'} : {height: 'max-content'} ">
